import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Planning/getVerracosSinExtraer`, method: 'GET', body: null, token: token})
}